import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import SuperBoyImg from '../Static/PSB_Screenshot.png';
import HMImg from '../Static/HeroMania_Logo01_sm.png';
import SteamLogo from '../Static/steamLogo.svg';
import PreviewPost from '../Blog/PreviewPost/PreviewPost'
import { Stack, Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import axios from '../api/axios'

function Main(props)  {
  const [blogList, setBlogList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [buttonSort, SetButtonSort] = useState("row");

//On load call
  useEffect(() => {
    async function fetchBlog(){
      const request = await axios.get('?key=AIzaSyAAM8G7_qThFyhznRCBeKmyDV5Xwl_0N5E');
      setBlogList(request.data.items)
      setLoaded(true)
      return request;
    }
    fetchBlog();
  }, []);

    useEffect(() => {
      if(props.windowWidth > 550){
        SetButtonSort("row")
      } else {
        SetButtonSort("column")
      }
  }, [props]);


//Handling blog response
  useEffect(() => {
    if(blogList === undefined || blogList.length <= 0)
      return;
  }, [blogList]);

if(blogList === undefined || blogList.length <= 0){
    return(
      <div className="loading-flex">
        <div className="loading-container">
          <CircularProgress className="loading-circle" color="secondary" />
        </div>
      </div>
    );
} else{
    return (
      <Fade in={loaded}>
        <div>
          <div>
            <div className="Button-Container">
              <a href="https://store.steampowered.com/app/1933520/Hero_Mania/" target="_blank" rel="noopener noreferrer">
                <img src={HMImg}  className="HM-Image" alt="Games"/>
              </a>
              <Button href="https://store.steampowered.com/app/1933520/Hero_Mania/" target="_blank" rel="noopener noreferrer" className="steam-button" variant="contained"  sx={{ borderRadius: '50px' }}>
                  <div className="Steam-Container">
                    <img src={SteamLogo} className="steam-logo" alt="Steam"/>
                      <span className="wishlist-text">Buy Today!</span>
                  </div>
              </Button>
                <Stack direction={buttonSort} spacing={3}>
                  <Button variant="outlined" className="action-button" target="_blank" rel="noopener noreferrer" href="https://drive.google.com/drive/folders/1es2Or2Hdt5Ydd_b6T_lnlW2EvegqTXB_?usp=drive_link" >Press Kit</Button>
                  <Button variant="outlined" className="action-button" target="_blank" rel="noopener noreferrer" href="https://linktr.ee/cosmictonic" >Follow Us!</Button>
                  <Button variant="outlined"  target="_blank" rel="noopener noreferrer" href="https://discord.gg/fRm3M26saZ" className="action-button">Discord</Button>
                </Stack>
            </div>
            <div className="image-body" style={{
      display: "inline-block",
      maskImage: "linear-gradient(to bottom, black 50%, transparent 100%)",
      WebkitMaskImage: "linear-gradient(to bottom, black 50%, transparent 100%)",
    }}>
              <img src={SuperBoyImg} className="PSB-Image" alt="Games"/>
            </div>
          </div>
          <div>
            <div className="Latest-News">
              <Typography className="Latest-News-Font" varient='h1'>Latest News</Typography>
            </div>
            <div className="news-container">
            {blogList.map(post => {
              return <PreviewPost key={post.id} post={post}/>
            })}
            </div>
          </div>
        </div>
      </Fade>
    );
  }
}

export default Main;
